import React, {useEffect, useState} from 'react';
import {DualAxes, G2} from "@ant-design/plots";
import {DatePicker, Select} from "antd";
import dayjs from "dayjs";
import moment from "moment/moment";
import axios from "axios";
import {API_PATH} from "../../components/const";

const dateFormat = 'YYYY-MM';


const {RangePicker} = DatePicker;


const VisitorDualAxes = () => {

    const { registerTheme } = G2;
    // registerTheme('custom-theme', {
    //     colors10: ['#5664D2','#FC53F5',  '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],
    //     colors20: [ '#5664D2', '#FC53F5', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],
    // });
    const [time, setTime] = useState(new Date());
    const [show, setShow] = useState(false);
    const [month, setMonth] = useState(time.getMonth());
    const [year, setYear] = useState(time.getFullYear());
    const [data, setData] = useState([
        {
            type: 'min',
            count: 0,
            date: "2023-12-12"
        },
        {
            type: 'max',
            count: 0,
            date: "2023-12-12"
        },
    ])
    const [dataLine, setDataLine] = useState([
        {
            type: 'avg',
            count: 0,
            date: "2023-12-12"
        }
    ])

    let formattedLastDay = new Date(time.getFullYear(), time.getMonth() + 1, 0);

    const getData = () => {

        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/visitor-duration/monthly-breakdown?year=" + time?.getFullYear() + "&month=" + Number(time?.getMonth() + 1), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData(res?.data?.filter(item => item?.type !== 'avg').map(item => {
                    return {
                        ...item,
                        type: item?.type === "min" ? "Минимум" : item?.type === "max" ?  "Максимум" : item?.type === "avg" ? "Средний" : "",
                        value: item?.count
                    }
                }))
                setDataLine(res?.data?.filter(item => item?.type === 'avg')?.map(item => {
                    return {
                        ...item,
                        type: "Средний",
                        value: item?.count
                    }
                }))
                setTimeout(() =>{
                    setShow(true)
                }, 500)
            })
            .catch(err =>{
                // console.log(err)
            })
    }

    const config = {
        data: [data, dataLine],
        xField: 'date',
        type: 'type',
        yField: ['value', 'value'],
        point: {
            size: 5,
            shape: 'diamond',
            style: {
                fill: 'white',
                stroke: '#00E480',
                lineWidth: 2,
            },
        },
        meta: {
            value: {
                alias: 'Средний',
            },
        },
        geometryOptions: [
            {
                geometry: 'column',
                isStack: true,
                seriesField: 'type',
                columnWidthRatio: 0.4,
                label: {},
                color:[ '#FC53F5','#5664D2'],
            },
            {
                geometry: 'line',
                color:'#00E480',
            },
        ],

        interactions: [
            {
                type: 'element-highlight',
            },
            {
                type: 'active-region',
            },
        ],
        animation: false,
        theme: 'custom-theme',
    };

    function onChange(date, dateString) {
            setShow(false)
            if (dateString[0] !== "") {
                axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/visitor-duration/monthly-breakdown?year=" + dateString?.slice(0, 4) + "&month=" + Number(dateString?.slice(5, 7)) , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                    .then(res => {
                        setData(res?.data?.filter(item => item?.type !== 'avg'))

                        setDataLine(res?.data?.filter(item => item?.type === 'avg'))

                        setTimeout(() =>{
                            setShow(true)

                        }, 500)
                    })

           } else {
                getData()
            }
        }

    useEffect(()=>{
        getData()
    }, [])
    return (
        <div className="visitor visitor-box w-100 dualaxes">
            <div className="chart-box  visitor-time-pie ">

                <div className="visitor-title align-items-center">
                    <h1><span>
                   Время посещения
                </span>
                        <div>
                           {/*<RangePicker*/}
                           {/*     placeholder={["Дата начала", "Дата окончания"]}*/}
                           {/*     defaultValue={[dayjs(moment().startOf('month').format('YYYY-MM-DD'), dateFormat), dayjs(moment().endOf('month').format('YYYY-MM-DD'), dateFormat)]}*/}
                           {/*     style={{width: "260px"}}*/}

                           {/*     format={dateFormat}*/}
                           {/*     onChange={onChange}*/}
                           {/* />*/}
                            <div className="d-flex">
                                <DatePicker picker="month"
                                            defaultValue={dayjs(year + "-" + (month < 9  ? "0" : "") + Number(month + 1), dateFormat)}
                                            onChange={onChange}
                                            placeholder="Выберите месяц"
                                            format={dateFormat}
                                />
                            </div>
                        </div>
                    </h1>
                </div>
                {/*<div className="d-flex justify-content-end">*/}
                {/*    <h4 className="pie-title">{dataTotal + " "} visitors</h4>*/}
                {/*</div>*/}

                {
                    show ?
                        <DualAxes {...config} />
                        :
                        ""
                }
            </div>
        </div>
    );
};

export default VisitorDualAxes;